<template>
  <div class="px-9 py-7">
    <div class="d-flex justify-space-between align-center mb-6">
      <span class="heading_one_line_chart">Member renewals</span>
      <span class="span_one">6.25K</span>
    </div>
    <div>
      <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
    <div class="mt-9">
      <div class="d-flex align-center">
        <v-card width="16" height="16" flat color="#0071BD"></v-card>
        <span class="span_two ml-3"> This month</span>
        <v-card
          width="16"
          height="16"
          flat
          color="#EAA413"
          class="ml-8"
        ></v-card>
        <span class="span_two ml-3"> Last month</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "MemberRenewalsLineChartComponent",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        labels: ["15/11", "16/11", "17/11", "18/11", "19/11", "20/11", "21/11"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "white",
            data: [0, 40, 39, 10, 40, 39, 80, 40],

            borderColor: "#0071BD",
            tension: 0.3,
            categoryPercentage: 0.3,
            borderRadius: 6,
          },
          {
            label: "Data One",
            backgroundColor: "white",
            data: [10, 29, 30, 40, 59, 60, 40],

            borderColor: "#EAA413",
            tension: 0.3,
            categoryPercentage: 0.3,
            borderRadius: 6,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            // position: "right",
            // labels: {
            //   usePointStyle: true,
            //   boxWidth: 10,
            //   display:false,
            // },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: true,
              borderColor: "transparent",
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.heading_one_line_chart {
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 600;
  color: #828282;
}
.span_one {
  font-family: "Nunito";
  font-size: 28px;
  font-weight: 600;
  color: #333333;
}
.span_two {
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 600;
  color: #222222;
}
</style>